// extracted by mini-css-extract-plugin
module.exports = {"trusted":"Trusted_trusted___gutB","trusted__inner":"Trusted_trusted__inner__UJDge","trusted__title":"Trusted_trusted__title__Tmq0q","trusted__img":"Trusted_trusted__img__7O_pT"};